import { api } from './client'

const markSessionActivity = () => {
  try { localStorage.setItem('asysLastActivityAt', String(Date.now())) } catch {}
}

export const login = async (username, password, tenantId) => {
  const body = { username, password }
  if (tenantId !== undefined && tenantId !== null && String(tenantId).trim() !== '') {
    body.tenant_id = Number(tenantId)
  }
  const { data } = await api.post('/auth/login', body)
  // For audit identity in dev or when session not sent yet in some envs
  try {
    if (data?.user_id) localStorage.setItem('actorId', String(data.user_id))
    if (data?.username) localStorage.setItem('actorName', data.full_name || data.username)
    if (data?.user_id) markSessionActivity()
  } catch {}
  return data
}

/** The plans, add-ons and prices, for the pricing page and signup (no sign-in needed). */
export const getPlans = async () => (await api.get('/auth/plans')).data

export const signup = async ({ company_name, full_name, username, password, email, business_type, time_zone, plan, addons, extra_users, extra_locations }) => {
  const { data } = await api.post('/auth/signup', { company_name, full_name, username, password, email, business_type, time_zone, plan, addons, extra_users, extra_locations })
  try {
    if (data?.user_id) localStorage.setItem('actorId', String(data.user_id))
    if (data?.username) localStorage.setItem('actorName', data.full_name || data.username)
    if (data?.user_id) markSessionActivity()
  } catch {}
  return data
}

export const logout = async () => {
  const { data } = await api.post('/auth/logout', {})
  try {
    localStorage.removeItem('actorId')
    localStorage.removeItem('actorName')
    localStorage.removeItem('asysLastActivityAt')
    localStorage.removeItem('asysIdleLogoutAt')
  } catch {}
  return data
}

export const me = async () => {
  const { data } = await api.get('/auth/me')
  return data
}

export const requestPasswordReset = async (email, tenantId) => {
  const body = { email }
  if (tenantId !== undefined && tenantId !== null && String(tenantId).trim() !== '') {
    body.tenant_id = Number(tenantId)
  }
  const { data } = await api.post('/auth/forgot-password', body)
  return data
}

export const resetPassword = async (token, newPassword) => {
  const body = { token, new_password: newPassword }
  const { data } = await api.post('/auth/reset-password', body)
  return data
}
